/**
 * Cycle count runs in two places: the back office (/back-office/inventory/cycle-count,
 * app.<domain>/inventory/cycle-count) on the owner's back-office sign-in, and the Admin
 * PWA (/admin/inventory/cycle-count) on the device's restaurant account. Both the list
 * and a task's count screen use these, so "Start" on the Admin PWA stays on the device
 * instead of opening the back office (which needs another sign-in).
 */
import { BO_BASE, pwaPath } from '@/utils/getBasePath';
import { accountHeaders } from '@/lib/pwaAccount';

export const inAdminPwa = () => /^\/(pwa\/)?admin(\/|$)/.test(window.location.pathname);

/** The cycle count list; with a task id, that task's count screen. */
export function cycleCountPath(taskId) {
  const base = inAdminPwa() ? pwaPath('admin', 'inventory/cycle-count') : `${BO_BASE}/inventory/cycle-count`;
  return taskId != null ? `${base}/${taskId}` : base;
}

export function cycleCountHeaders() {
  if (inAdminPwa()) return accountHeaders({ 'Content-Type': 'application/json' });
  const token = localStorage.getItem('backoffice_token');
  const branchId = localStorage.getItem('current_branch_id');
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'X-Merchant-ID': localStorage.getItem('backoffice_active_restaurant') || '',
    ...(branchId ? { 'X-Branch-Id': branchId } : {}),
  };
}
